module.exports = __webpack_public_path__ + "static/media/mail.ea8fba02.svg";